import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Menu, X, Phone } from 'lucide-react';

const LOGO_URL = "https://customer-assets.emergentagent.com/job_087dcaaa-f596-41d4-9f4c-171b9ddad075/artifacts/wvrmtjxe_LOGO%20DR%20EDU%20HADAS.PNG";
const WHATSAPP_LINK = "https://wa.me/5541988451399?text=Olá,%20gostaria%20de%20agendar%20uma%20avaliação%20médica.";

const navItems = [
  { label: 'Início', path: '/' },
  { label: 'Sobre', path: '/sobre' },
  { label: 'Emagrecimento', path: '/emagrecimento' },
  { label: 'Reposição Hormonal', path: '/reposicao-hormonal' },
  { label: 'Como Funciona', path: '/como-funciona' },
  { label: 'Blog', path: '/blog' },
];

export const Navbar = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  // Close mobile menu on route change
  const prevLocation = React.useRef(location.pathname);
  if (prevLocation.current !== location.pathname) {
    prevLocation.current = location.pathname;
    if (isMenuOpen) {
      setIsMenuOpen(false);
    }
  }

  return (
    <nav 
      data-testid="navbar"
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled 
          ? 'bg-[#FAF9F7]/95 backdrop-blur-md shadow-sm py-4' 
          : 'bg-transparent py-6'
      }`}
    >
      <div className="container-custom flex items-center justify-between">
        {/* Logo */}
        <Link to="/" data-testid="navbar-logo" className="flex items-center">
          <img 
            src={LOGO_URL} 
            alt="Dr. Eduardo Hadas" 
            className="h-12 md:h-14 w-auto object-contain"
            style={{ filter: isScrolled ? 'none' : 'brightness(0) invert(0)' }}
          />
        </Link>

        {/* Desktop Navigation */}
        <div className="hidden lg:flex items-center gap-8">
          {navItems.map((item) => (
            <Link
              key={item.path}
              to={item.path}
              data-testid={`nav-link-${item.path.replace('/', '') || 'home'}`}
              className={`nav-link ${location.pathname === item.path ? 'text-[#B8944D]' : ''}`}
            >
              {item.label}
            </Link>
          ))}
        </div>

        {/* CTA Button */}
        <div className="hidden lg:block">
          <a
            href={WHATSAPP_LINK}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="navbar-cta-button"
            className="btn-primary flex items-center gap-2"
          >
            <Phone className="w-4 h-4" />
            Agendar avaliação
          </a>
        </div>

        {/* Mobile Menu Button */}
        <button
          data-testid="mobile-menu-button"
          className="lg:hidden p-2"
          onClick={() => setIsMenuOpen(!isMenuOpen)}
          aria-label={isMenuOpen ? 'Fechar menu' : 'Abrir menu'}
        >
          {isMenuOpen ? (
            <X className="w-6 h-6 text-[#2A2A2A]" />
          ) : (
            <Menu className="w-6 h-6 text-[#2A2A2A]" />
          )}
        </button>
      </div>

      {/* Mobile Menu */}
      <div
        data-testid="mobile-menu"
        className={`lg:hidden fixed inset-0 top-0 bg-[#FAF9F7] z-40 transition-transform duration-300 ${
          isMenuOpen ? 'translate-x-0' : 'translate-x-full'
        }`}
      >
        <div className="flex flex-col h-full pt-24 px-6">
          <div className="flex flex-col gap-6">
            {navItems.map((item) => (
              <Link
                key={item.path}
                to={item.path}
                data-testid={`mobile-nav-link-${item.path.replace('/', '') || 'home'}`}
                className={`text-2xl font-light ${
                  location.pathname === item.path 
                    ? 'text-[#B8944D]' 
                    : 'text-[#2A2A2A]'
                }`}
                style={{ fontFamily: 'var(--font-heading)' }}
              >
                {item.label}
              </Link>
            ))}
          </div>
          
          <div className="mt-auto pb-12">
            <a
              href={WHATSAPP_LINK}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="mobile-cta-button"
              className="btn-primary w-full flex items-center justify-center gap-2"
            >
              <Phone className="w-5 h-5" />
              Agendar avaliação médica
            </a>
          </div>
        </div>
      </div>
    </nav>
  );
};
